import MeditationLibrary, { ENERGY_SESSIONS } from "@/components/MeditationLibrary";
import Reveal from "@/components/Reveal";

const BARS = 36;

export default function Energy() {
  return (
    <section id="energy" data-testid="energy-section" className="relative overflow-hidden px-5 py-24 sm:px-8 sm:py-32">
      <div className="nebula nebula-c" aria-hidden="true" />
      <div className="relative z-10 mx-auto max-w-5xl text-center">
        <Reveal>
          <p className="eyebrow mb-5" data-testid="energy-eyebrow">Transmission Pending</p>
          <h2
            data-testid="energy-heading"
            className="font-display text-3xl font-bold uppercase leading-tight tracking-[0.12em] text-slate-100 sm:text-4xl lg:text-5xl"
          >
            Energy &amp; <span className="text-glow-cyan text-cyan-300">Frequency</span>
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="mx-auto mt-7 max-w-2xl text-sm leading-relaxed text-slate-400 sm:text-base" data-testid="energy-body">
            Everything is energy. Your thoughts carry a charge, your emotions a vibration, your
            attention a direction. Now you can hear it — tune into the frequency library below.
          </p>
        </Reveal>

        <Reveal delay={0.25}>
          <div
            data-testid="energy-wave-visual"
            className="mx-auto mt-14 flex h-32 max-w-3xl items-end justify-center gap-1 rounded-3xl border border-fuchsia-400/15 bg-fuchsia-950/10 px-6 py-6 backdrop-blur-sm sm:gap-1.5"
          >
            {Array.from({ length: BARS }).map((_, i) => (
              <span
                key={i}
                className="eq-bar w-1 bg-gradient-to-t from-fuchsia-500 via-violet-400 to-cyan-300 sm:w-1.5"
                style={{
                  height: `${25 + 75 * Math.abs(Math.sin(i * 0.55))}%`,
                  animationDelay: `${i * 0.09}s`,
                  animationDuration: `${2.2 + (i % 5) * 0.3}s`,
                }}
              />
            ))}
          </div>
        </Reveal>

        <MeditationLibrary
          prefix="energy"
          eyebrow="Tune In"
          sessions={ENERGY_SESSIONS}
          body="The deeper cuts of the Solfeggio scale — 174, 285, 396, and 852Hz. Four soundscapes generated live in your browser. Choose a frequency, press play, and feel the dialogue between your inner and outer world."
        />
      </div>
    </section>
  );
}
